module.exports = __webpack_public_path__ + "static/media/glacier.5e77d354.jpeg";